//#region imports
import React from 'react';

// bootstrap
import { Row, Col } from 'react-bootstrap';

// icons
import { FiUser } from "react-icons/fi";

// styles
import { Spacing, Colors } from '_styles';

//#endregion

/**
 * EmployeeList Component
 * 
 * Displays a list of employees assigned to a flight with their details.
 */
const EmployeeList = ({ employeeList, headerColor }) => {

    if (!employeeList || employeeList.length === 0) {
        return null;
    }

    const bgColor = headerColor || Colors.PRM_LIGHT_BLUE;

    return (
        <div style={{ marginTop: Spacing.SCALE_24 }}>
            {/* Title header */}
            <div style={{
                marginBottom: Spacing.SCALE_12,
                display: 'flex',
                alignItems: 'center',
                gap: Spacing.SCALE_8,
                backgroundColor: bgColor,
                padding: '10px 16px',
                borderRadius: '8px',
            }}>
                <FiUser size={18} color="white" />
                <span style={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '14px'
                }}>
                    Assigned Employees ({employeeList.length})
                </span>
            </div>
            <div style={{
                border: `1px solid ${Colors.GRAY_LIGHT || '#e5e7eb'}`,
                borderRadius: '8px',
                overflow: 'hidden',
            }}>
                {/* Table Header */}
                <div style={{
                    backgroundColor: Colors.GRAY_LIGHT || '#f3f4f6',
                    padding: '10px 16px',
                    borderBottom: `1px solid ${Colors.GRAY_LIGHT || '#e5e7eb'}`,
                }}>
                    <Row>
                        <Col xs={4}>
                            <strong style={{ fontSize: '13px' }}>Name</strong>
                        </Col>
                        <Col xs={3}>
                            <strong style={{ fontSize: '13px' }}>Role</strong>
                        </Col>
                        <Col xs={3}>
                            <strong style={{ fontSize: '13px' }}>Status</strong>
                        </Col>
                        <Col xs={2}>
                            <strong style={{ fontSize: '13px' }}>Equipment</strong>
                        </Col>
                    </Row>
                </div>
                {/* Employee rows */}
                {employeeList.map((employee, idx) => (
                    <div
                        key={employee.userId || idx}
                        style={{
                            padding: '12px 16px',
                            borderBottom: idx < employeeList.length - 1 ? `1px solid ${Colors.GRAY_LIGHT || '#e5e7eb'}` : 'none',
                            backgroundColor: idx % 2 === 0 ? 'white' : '#fafafa',
                        }}
                    >
                        <Row style={{ alignItems: 'center' }}>
                            <Col xs={4}>
                                <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                    {employee.title || employee.name || 'Unknown'}
                                </span>
                            </Col>
                            <Col xs={3}>
                                <span style={{
                                    fontSize: '13px',
                                    textTransform: 'uppercase',
                                    color: Colors.GRAY_MEDIUM || '#6b7280'
                                }}>
                                    {employee.role || '-'}
                                </span>
                            </Col>
                            <Col xs={3}>
                                <span style={{
                                    fontSize: '12px',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    backgroundColor: employee.status === 'online' ? '#dcfce7' : '#f3f4f6',
                                    color: employee.status === 'online' ? '#166534' : '#6b7280',
                                }}>
                                    {employee.status || 'unknown'}
                                    {/*TODO, process status after new updates */}
                                </span>
                            </Col>
                            <Col xs={2}>
                                <span style={{ fontSize: '13px', color: Colors.GRAY_MEDIUM || '#6b7280' }}>
                                    {employee.employeeEquipment || '-'}
                                </span>
                            </Col>
                        </Row>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EmployeeList;
